<template>
		<layout-login>
			<div class="main-login" :style="`background-image: url(${companyBgUrl})`">
				<div class="background-opacity"></div>
				<div class="login-logo">
					<img
						:src="loginLogo"
						alt="praktiko logo"
						height="131"
						width="345"
					>
				</div>
				<div class="login-logo-company" v-if="urlImageCompany">
					<img
						:src="urlImageCompany"
						alt="company logo"
						height="131"
						width="200"
					>
				</div>
				<p-card class="content-form tw-p-none overflow-hidden" v-if="dataForApplications">
					<p-header-dialog :negative-margin="false" :no-icon="true">
						Ingrese sus Datos para la postulación al Puesto <span class="text-uppercase">{{ dataForApplications.job.name }}</span>
					</p-header-dialog>
					<section class="form-applicant tw-flex tw-flex-col tw-justify-between tw-gap-3 tw-p-6">
						<div class="text-sm">
							<span :style="`color:${$appColors.error}`">Los campos con (*) son obligatorios.<br>Recuerde el Nro. Documento debe contener 10 digitos y debe ingresar un correo válido.<br>No olvides subir una foto al sistema para completar tu perfil en formato.jpeg</span>
						</div>
						<v-layout row class="tw-flex tw-justify-between tw-items-center">
							<v-flex xs10>
								<v-layout row class="tw-flex tw-justify-between tw-items-center tw-mb-5 tw-gap-12">
									<v-flex xs2>
										<label :style="`color:${$appColors.info}; font-weight: bold;`">Nombres:</label>
									</v-flex>
									<v-flex xs10 class="tw-flex tw-items-center tw-gap-x-3">
										<input
											class="form-applicant-input"
											type="text"
											v-model="applicant.name">
										<span
											class="text-lg" v-if="!$v.applicant.name.required"
											:style="`color:${$appColors.error}`">*
										</span>
									</v-flex>
								</v-layout>
								<v-layout row class="tw-flex tw-justify-between tw-items-center tw-gap-12">
									<v-flex xs2>
										<label :style="`color:${$appColors.info}; font-weight: bold;`">Apellidos:</label>
									</v-flex>
									<v-flex xs10 class="tw-flex tw-items-center tw-gap-x-3">
										<input
											class="form-applicant-input"
											type="text"
											v-model="applicant.lastName">
										<span
											class="text-lg" v-if="!$v.applicant.lastName.required"
											:style="`color:${$appColors.error}`">
											*
										</span>
									</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs2 class="tw-flex tw-justify-end">
								<div :class="validateImage ? 'wrapper-user-image-error' : 'wrapper-user-image'">
									<div class="wrapper-user">
										<img
											:src="urlImage"
											alt="user"
											height="100%"
											width="100%">
									</div>
									<div class="wrapper-camera">
										<load-file
											:show-input="false"
											:code="codeCompany"
											:disabled="!applicant.documentNumber"
											:name-file="applicant.documentNumber"
											icon="camera_alt"
											color="white"
											class-btn="circle-btn"
											@input="getImage">
										</load-file>
									</div>
								</div>
							</v-flex>
						</v-layout>
						<v-layout row class="tw-flex tw-justify-between tw-items-center tw-gap-6">
							<v-flex xs2>
								<label :style="`color:${$appColors.info}; font-weight: bold;`">Tipo de Documento:</label>
							</v-flex>
							<v-flex xs4 class="tw-flex tw-items-center tw-gap-x-3">
								<v-select
									solo
									class="custom-select-form-applicants"
									:items="typeDocuments"
									item-text="name"
									item-value="id"
									v-model="applicant.typeDocument"
								></v-select>
								<span
									class="text-lg" v-if="!$v.applicant.typeDocument.required"
									:style="`color:${$appColors.error}`">
									*
								</span>
							</v-flex>
							<v-flex xs2 class="tw-pl-4">
								<label :style="`color:${$appColors.info}; font-weight: bold;`">Nro. Documento:</label>
							</v-flex>
							<v-flex xs4 class="tw-flex tw-items-center tw-gap-x-3">
								<input
									class="form-applicant-input"
									type="number"
									v-model="applicant.documentNumber">
								<span
									class="text-lg" v-if="!$v.applicant.documentNumber.required || !$v.applicant.documentNumber.maxLength"
									:style="`color:${$appColors.error}`">
									*
								</span>
							</v-flex>
						</v-layout>
						<v-layout row class="tw-flex tw-justify-between tw-items-center tw-gap-6">
							<v-flex xs2>
								<label :style="`color:${$appColors.info}; font-weight: bold;`">Teléfono:</label>
							</v-flex>
							<v-flex xs4 class="tw-flex tw-items-center tw-gap-x-3">
								<input
									class="form-applicant-input"
									type="number"
									v-model="applicant.phone">
								<span
									class="text-lg" v-if="!$v.applicant.phone.required"
									:style="`color:${$appColors.error}`">
									*
								</span>
							</v-flex>
							<v-flex xs2 class="tw-pl-4">
								<label :style="`color:${$appColors.info}; font-weight: bold;`">Correo:</label>
							</v-flex>
							<v-flex xs4 class="tw-flex tw-items-center tw-gap-x-3">
								<input
									class="form-applicant-input"
									placeholder="example@gmail.com"
									type="text"
									v-model="applicant.email">
								<span
									class="text-lg" v-if="!$v.applicant.email.required || !$v.applicant.email.email"
									:style="`color:${$appColors.error}`">
									*
								</span>
							</v-flex>
						</v-layout>
						<v-layout row class="tw-flex tw-justify-between tw-items-center tw-gap-6">
							<v-flex xs2>
								<label :style="`color:${$appColors.info}; font-weight: bold;`">Género:</label>
							</v-flex>
							<v-flex xs4 class="tw-flex tw-items-center tw-gap-x-3">
								<v-select
									solo
									class="custom-select-form-applicants"
									:items="gender"
									item-text="name"
									item-value="id"
									v-model="applicant.gender"
								></v-select>
								<span
									class="text-lg" v-if="!$v.applicant.gender.required"
									:style="`color:${$appColors.error}`">
									*
								</span>
							</v-flex>
							<v-flex xs2 class="tw-pl-4">
								<label :style="`color:${$appColors.info}; font-weight: bold;`">Estado Civil:</label>
							</v-flex>
							<v-flex xs4 class="tw-flex tw-items-center tw-gap-x-3">
								<v-select
									solo
									class="custom-select-form-applicants"
									:items="civilStatus"
									item-text="name"
									item-value="id"
									v-model="applicant.civilStatusId"
								></v-select>
								<span
									class="text-lg" v-if="!$v.applicant.civilStatusId.required"
									:style="`color:${$appColors.error}`">
									*
								</span>
							</v-flex>
						</v-layout>
						<v-layout row class="tw-flex tw-justify-between tw-items-center tw-gap-6">
							<v-flex xs2>
								<label :style="`color:${$appColors.info}; font-weight: bold;`">Edad:</label>
							</v-flex>
							<v-flex xs4 class="tw-flex tw-items-center tw-gap-x-3">
								<input
									class="form-applicant-input"
									type="number"
									v-model="applicant.age">
								<span
									class="text-lg" v-if="!$v.applicant.age.required"
									:style="`color:${$appColors.error}`">
									*
								</span>
							</v-flex>
							<v-flex xs2 class="tw-pl-4">
								<label :style="`color:${$appColors.info}; font-weight: bold;`">Discapacidad:</label>
							</v-flex>
							<v-flex xs4 class="tw-flex tw-items-center tw-gap-x-3">
								<v-select
									solo
									class="custom-select-form-applicants"
									:items="disabilities"
									item-text="name"
									item-value="id"
									v-model="applicant.disability"
								></v-select>
								<span
									class="text-lg" v-if="!$v.applicant.disability.required"
									:style="`color:${$appColors.error}`">
									*
								</span>
							</v-flex>
						</v-layout>
						<v-layout row class="tw-flex tw-justify-between tw-items-center tw-gap-6">
							<v-flex xs2>
								<label :style="`color:${$appColors.info}; font-weight: bold;`">CV (Link):</label>
							</v-flex>
							<v-flex xs4>
								<input
									class="form-applicant-input"
									type="text"
									v-model="applicant.cv">
							</v-flex>
							<v-flex xs2 class="tw-pl-4">
								<label :style="`color:${$appColors.info}; font-weight: bold;`">Lugar de residencia:</label>
							</v-flex>
							<v-flex xs4 class="tw-flex tw-items-center tw-gap-x-3">
								<input
									class="form-applicant-input"
									type="text"
									placeholder="Ciudad, Dirección(Sector, Calles)"
									v-model="applicant.placeOfResidence">
								<span
									class="text-lg" v-if="!$v.applicant.placeOfResidence.required"
									:style="`color:${$appColors.error}`">
									*
								</span>
							</v-flex>
						</v-layout>
						<v-layout row class="tw-flex tw-justify-start tw-items-center tw-gap-6">
							<v-flex xs3>
								<label :style="`color:${$appColors.info}; font-weight: bold;`">Aspiración Salarial:</label>
							</v-flex>
							<v-flex xs3 class="tw-flex tw-items-center tw-gap-x-3">
								<input
									class="form-applicant-input"
									type="number"
									v-model="applicant.salaryExpectation">
								<span
									class="text-lg" v-if="!$v.applicant.salaryExpectation.required"
									:style="`color:${$appColors.error}`">
									*
								</span>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<div class="tw-flex tw-flex-col tw-w-full">
								<div class="title-questions tw-my-4">
									<h3>Responda las siguientes preguntas de acuerdo a su criterio.</h3>
								</div>
								<form class="questions">
									<p ref="firstQuestion">1. Tiene {{ this.dataInstruction.description.instructions[0].name }} en: {{ careersName }}
									<span
										class="text-lg" v-if="!questions.firstQuestion.value"
										:style="`color:${$appColors.error}`">
										*
									</span></p>
									<v-radio-group v-model="questions.firstQuestion.value" class="radio-options">
										<!-- <div class="tw-flex tw-px-3 tw-justify-between tw-gap-x-5"> -->
											<v-radio
												class="custom-checkbox"
												color="success"
												style="background: white;"
												label="Si" value="Si"></v-radio>
											<v-radio
												class="custom-checkbox"
												color="success"
												style="background: white;"
												label="No" value="No"></v-radio>
										<!-- </div> -->
									</v-radio-group>
									<p ref="secondQuestion">2. Has trabajado como: {{ dataExperience.description[0].detail }}
									<span
										class="text-lg" v-if="!questions.secondQuestion.value"
										:style="`color:${$appColors.error}`">
										*
									</span></p>
									<v-radio-group v-model="questions.secondQuestion.value" class="radio-options">
										<!-- <div class="tw-flex tw-px-3 tw-justify-between tw-gap-x-5"> -->
											<v-radio
												class="custom-checkbox"
												color="success"
												style="background: white;"
												:label="dataExperience.description[0].experience.name" value="Si"></v-radio>
											<v-radio
												class="custom-checkbox"
												color="success"
												style="background: white;"
												label="No tengo Experiencia" value="No"></v-radio>
										<!-- </div> -->
									</v-radio-group>
									<p ref="thirdQuestion">3. Aceptas trabajar de forma presencial en: {{ dataForApplications.recruitmentProcess.details.location }}
									<span
										class="text-lg" v-if="!questions.thirdQuestion.value"
										:style="`color:${$appColors.error}`">
										*
									</span></p>
									<v-radio-group v-model="questions.thirdQuestion.value" class="radio-options">
										<!-- <div class="tw-flex tw-px-3 tw-justify-between tw-gap-x-5"> -->
											<v-radio
												class="custom-checkbox"
												color="success"
												style="background: white;"
												label="Si" value="Si"></v-radio>
											<v-radio
												class="custom-checkbox"
												color="success"
												style="background: white;"
												label="No" value="No"></v-radio>
										<!-- </div> -->
									</v-radio-group>
									<p>4. Señala el nivel de competencias que posees actualmente:</p>
									<ul v-for="(competence, index) in dataCompetences.description" :key="index">
										<li>{{ competence.name }}
											<span
												class="text-lg" v-if="!questions.levelCompetences[index]"
												:style="`color:${$appColors.error}`">
												*
											</span>
										</li>
										<v-radio-group class="radio-list">
											<div class="tw-flex tw-px-3 tw-justify-between tw-gap-x-5">
												<div v-for="(level, indexL) in levelCompetence" :key="indexL">
													<v-radio
														class="custom-checkbox"
														color="success"
														style="background: white;"
														:label="level.name" :value="level.value"
														@change="handleCompetenceChange(competence, index, level)"></v-radio>
												</div>
											</div>
										</v-radio-group>
									</ul>
									<v-checkbox
										v-model="questions.confidentialityInformation.value"
										:label="questions.confidentialityInformation.text"
										hide-details
										color="success"
										style="background: white"
										class="custom-checkbox"
									>
									</v-checkbox>
									<div class="tw-flex tw-mt-6 tw-justify-center">
										<vue-recaptcha
											@verify="onRecaptchaVerified"
											sitekey="6LfsIKgpAAAAAIYbAxtjaTzvJ9mbJJgfz8Uaj0O7">
										</vue-recaptcha>
									</div>
								</form>
							</div>
						</v-layout>
					</section>
					<p-horizontal-divider></p-horizontal-divider>
					<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
						<p-button
							type="primary"
							:disabled="!isValidated || validateImage || validateQuestions || !isRecaptchaVerified"
							@click="savedNewApplicant"
							> Enviar Postulación
						</p-button>
					</div>
				</p-card>
			</div>
		</layout-login>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import PButton from '@/modules/shared/components/ui/p-button';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';
import loadFile from '@/components/shared/load-image';
import VueRecaptcha from 'vue-recaptcha';
import { required, email, maxLength } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

function beforeCreate() {
}

function created() {
	this.urlImage = 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/user-null.svg';
	const { id, code, idCompany } = this.$route.params;
	this.codeCompany = code;
	this.listProcessRecruitment(id, idCompany);
}

function isValidated() {
	return (
		this.$v.applicant.name.required &&
		this.$v.applicant.lastName.required &&
		this.$v.applicant.typeDocument.required &&
		this.$v.applicant.documentNumber.required &&
		this.$v.applicant.documentNumber.maxLength &&
		this.$v.applicant.phone.required &&
		this.$v.applicant.email.required && this.$v.applicant.email.email &&
		this.$v.applicant.gender.required &&
		this.$v.applicant.civilStatusId.required &&
		this.$v.applicant.age.required &&
		this.$v.applicant.disability.required &&
		this.$v.applicant.placeOfResidence.required &&
		this.$v.applicant.salaryExpectation.required
	);
}

async function listProcessRecruitment(id, idCompany) {
	const body = {
		id: Number(id),
		companyId: Number(idCompany),
	};
	try {
		const { data: response } = await this.$httpPraktiko.post('recruitment/detail-no-auth', body);
		this.dataInstruction = response.steps.profiles.find(i => i.code === 'FINS');
		this.dataExperience = response.steps.profiles.find(e => e.code === 'EXPR');
		this.dataCompetences = response.steps.profiles.find(c => c.code === 'RDSK');
		this.dataForApplications = response;
		this.urlImageCompany = response.company.urlImage.web;
	} catch (error) {
		if (error.data.message === 'EXPIRED_RECRUITMENT_PROCESS') {
			this.showGenericError('El Procesos de Reclutamiento ha Finalizado');
		}
		this.goTo('login');
	}
}

function validations() {
	return {
		applicant: {
			name: { required },
			lastName: { required },
			typeDocument: { required },
			documentNumber: { required, maxLength: maxLength(10) },
			phone: { required },
			email: { email, required },
			gender: { required },
			civilStatusId: { required },
			age: { required },
			disability: { required },
			placeOfResidence: { required },
			salaryExpectation: { required },
		},
	};
}

function loginLogo() {
	return process.env.LOGO_LOGIN;
}

function getImage(url) {
	this.urlImage = url;
}

function handleCompetenceChange(competence, index, level) {
	this.$set(this.questions.levelCompetences, index, {});
	this.$set(this.questions.levelCompetences[index], 'level', level);
	this.$set(this.questions.levelCompetences[index], 'nameCompetence', competence.name);
}

async function savedNewApplicant() {
	const firstQuestion = this.$refs.firstQuestion.innerText;
	this.questions.firstQuestion.question = firstQuestion;
	const secondQuestion = this.$refs.secondQuestion.innerText;
	this.questions.secondQuestion.question = secondQuestion;
	const thirdQuestion = this.$refs.thirdQuestion.innerText;
	this.questions.thirdQuestion.question = thirdQuestion;
	const { id, idCompany } = this.$route.params;
	const body = {
		additionalInformation: {
			salaryExpectation: Number(this.applicant.salaryExpectation),
			typeApplicant: {
				id: this.applicant.typeApplicantId.id,
				name: this.applicant.typeApplicantId.name,
			},
			placeOfResidence: this.applicant.placeOfResidence,
			questions: this.questions,
		},
		name: this.applicant.name,
		lastName: this.applicant.lastName,
		phoneNumber: this.applicant.phone,
		typeDocument: this.applicant.typeDocument,
		documentNumber: this.applicant.documentNumber,
		email: this.applicant.email,
		gender: this.applicant.gender,
		civilStatusId: this.applicant.civilStatusId,
		age: Number(this.applicant.age),
		disability: this.applicant.disability,
		salaryExpectation: Number(this.applicant.salaryExpectation),
		typeApplicantId: this.applicant.typeApplicantId.id,
		status: this.applicant.status,
		urlImage: this.urlImage,
		recruitmentId: id,
		cv: this.applicant.cv,
		companyId: Number(idCompany),
	};
	try {
		await this.$httpPraktiko.post('applicants-recruitment/no-auth', body);
		this.showNotification('Postulación Exitosa');
		this.goTo('login');
	} catch (error) {
		if (error.data.message === 'APPLICANT_ALREADY_EXIST_IN_RECRUITMENT') {
			this.showNotification(`Ya se ha registrado un postulante con el número de Identificación ${this.applicant.documentNumber}`, 'warning');
		} else {
			this.showGenericError();
		}
	}
}

function validateImage() {
	if (this.urlImage === 'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/user-null.svg') {
		return true;
	}
	return false;
}

function onRecaptchaVerified() {
	this.isRecaptchaVerified = true;
	setTimeout(() => {
		this.isRecaptchaVerified = false;
	}, 60000);
}

function data() {
	return {
		companyBgUrl: '/static/img/login/background-praktiko.jpg',
		dataForApplications: {},
		dataInstruction: {},
		dataExperience: {},
		dataCompetences: {},
		questions: {
			firstQuestion: {
				question: '',
				value: null,
			},
			secondQuestion: {
				question: '',
				value: null,
			},
			thirdQuestion: {
				question: '',
				value: null,
			},
			levelCompetences: [],
			confidentialityInformation: {
				value: false,
				text: 'Entiendo y acepto que mi información sea utilizada conforme a las políticas de privacidad y términos de uso.',
			},
		},
		urlImageCompany: null,
		isLoading: false,
		showPass: false,
		codeCompany: null,
		applicant: {
			name: '',
			lastName: '',
			typeDocument: null,
			documentNumber: null,
			phone: '',
			email: '',
			gender: null,
			civilStatusId: null,
			age: null,
			disability: '',
			salaryExpectation: null,
			typeApplicantId: {
				id: 269,
				name: 'Postulante',
			},
			status: true,
			cv: null,
			placeOfResidence: null,
		},
		gender: [
			{ id: 1, name: 'Masculino' },
			{ id: 2, name: 'Femenino' },
		],
		civilStatus: [
			{
				id: 264,
				name: 'Soltero/a',
			},
			{
				id: 265,
				name: 'Casado/a',
			},
			{
				id: 266,
				name: 'Divorciado/a',
			},
			{
				id: 267,
				name: 'Viudo/a',
			},
			{
				id: 268,
				name: 'Unión Libre',
			},
		],
		typeDocuments: [
			{
				id: 7,
				name: 'Cédula de Identidad',
			},
		],
		levelCompetence: [
			{
				value: 0,
				name: 'Poco Desarrollado',
			},
			{
				value: 1,
				name: 'Medianamente Desarrollado',
			},
			{
				value: 2,
				name: 'Desarrollado',
			},
			{
				value: 3,
				name: 'Muy Desarrollado',
			},
		],
		urlImage: null,
		disabilities: [
			{
				id: 'NO',
				name: 'NO',
			},
			{
				id: 'SI',
				name: 'SI',
			},
		],
		isRecaptchaVerified: false,
	};
}

export default {
	name: 'page-applications',
	components: {
		PHeaderDialog,
		PButton,
		CloseIcon,
		PCard,
		PHorizontalDivider,
		loadFile,
		VueRecaptcha,
	},
	data,
	beforeCreate,
	created,
	methods: {
		savedNewApplicant,
		getImage,
		listProcessRecruitment,
		handleCompetenceChange,
		onRecaptchaVerified,
	},
	computed: {
		isValidated,
		validateImage,
		loginLogo,
		...mapGetters([
			'idProcess',
		]),
		careersName() {
			const names = this.dataInstruction.description.instructions[0].career.join(', ');
			return names;
		},
		validateQuestions() {
			return !this.questions.firstQuestion || !this.questions.secondQuestion
				|| !this.questions.thirdQuestion
				|| this.questions.levelCompetences.length < this.dataCompetences.description.length
				|| !this.questions.confidentialityInformation.value;
		},
	},
	validations,
};
</script>

<style lang="scss" scoped>
.main-login {
	@include flex-around;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	height: 100vh;

	.background-opacity {
		background-image: linear-gradient(280deg, rgba(255, 255, 255, 0.41),
			rgba(255, 255, 255, 0.96) 76%,
			rgba(255, 255, 255, 0.96));
		bottom: 0;
		left: 0;
		position: absolute;
		right: 0;
		top: 0;
	}
	.login-logo {
		position: absolute;
		display: flex;
		justify-content: end;
		right: 50px;
		top: 50px;
		img {
			width: 40%;
			height: auto;
		}
	}
	.login-logo-company {
		position: absolute;
		display: flex;
		justify-content: end;
		padding: 0% !important;
		right: 50px;
		top: 150px;
		img {
			margin: 0% !important;
			padding: 0% !important;
			width: 30%;
			height: 30%;
		}
	}
	.content-form {
		position: absolute;
		text-align: center;
		left: 20px;
		width: 60%;
		z-index: 5;

		.form-applicant {
			width: 100%;
			overflow: auto;
			height: 70vh;
			text-align: left;

			.wrapper-user-image {
				width: 120px;
				position: relative;
				&-error {
					border: 1px solid color(error);
					width: 120px;
					position: relative;
				}
			}


			.wrapper-camera {
				bottom: -1px;
				position: absolute;
				right: 13px;
			}
			&-input {
				background: map-get($colors, white);
				border: 1px solid map-get($colors, placeholder);
				border-radius: 4px;
				display: block;
				outline: none;
				color: map-get($colors, gray-sidebar);
				padding: 10px 20px;
				width: 100%;

				&::placeholder {
					color: map-get($colors, placeholder) !important;
				}
			}
			&-input-error {
				background: map-get($colors, white);
				border: 1px solid map-get($colors, error);
				border-radius: 4px;
				display: block;
				outline: none;
				color: map-get($colors, gray-sidebar);
				padding: 10px 20px;
				width: 100%;

				&::placeholder {
					color: map-get($colors, placeholder) !important;
				}
			}
			.title-questions {
				color: color(gray-sidebar);
				font-size: size(large);
				text-align: center;
			}
			.questions {
				display: flex;
				flex-direction: column;
				justify-content: start;
				text-align: start;
				color: color(gray-sidebar);
				font-size: size(large);
				p {
					font-weight: 900;
				}
			}
		}
	}

}
.radio-options {
	display: flex;
	padding-left: 170px;
}
.radio-list {
    display: flex;
	justify-content: center;
	width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/page-applications.vue